type SelfPayerCatalogue = {
  durations: { minutes: number; priceLabel: string }[];
  additionalTreatments: { name: string; priceLabel: string }[];
};

// Labels are German: the add-on names double as the source of the reception note text.
const DEFAULT_SELF_PAYER_CATALOGUE: SelfPayerCatalogue = {
  durations: [
    { minutes: 20, priceLabel: "30€" },
    { minutes: 40, priceLabel: "60€" },
    { minutes: 60, priceLabel: "90€" },
  ],
  additionalTreatments: [
    { name: "Fango Packung", priceLabel: "10€" },
    { name: "Elektrotherapie", priceLabel: "10€" },
    { name: "Kinesiotaping", priceLabel: "10€" },
  ],
};

// Prices are maintained per location; all six currently share the same list.
const SELF_PAYER_CATALOGUE_BY_PRACTICE: Record<string, SelfPayerCatalogue | undefined> = {
  recaZycTgCafX00x0: DEFAULT_SELF_PAYER_CATALOGUE, // Wedding
  recFAwdZhxEITTXD1: DEFAULT_SELF_PAYER_CATALOGUE, // Charlottenburg-Wilmersdorf
  receZOUTC8OHPqHWA: DEFAULT_SELF_PAYER_CATALOGUE, // Reinickendorf
  recTkCYv3nHQgr02m: DEFAULT_SELF_PAYER_CATALOGUE, // Mitte
  "c89c6b77-77ab-4c57-a145-2c1f70f5dd78": DEFAULT_SELF_PAYER_CATALOGUE, // Neukölln
  "9ae55e54-dda1-4314-b9df-d52717ed20f0": DEFAULT_SELF_PAYER_CATALOGUE, // Schäfersee
};

// An unknown practice id falls back to the default catalogue rather than skipping the screens.
export const getSelfPayerCatalogue = (practiceId: string | undefined): SelfPayerCatalogue =>
  (practiceId ? SELF_PAYER_CATALOGUE_BY_PRACTICE[practiceId] : undefined) ??
  DEFAULT_SELF_PAYER_CATALOGUE;

export const formatDurationOptionLabel = (minutes: number, priceLabel: string) =>
  `${minutes} min (${priceLabel})`;

export const formatAdditionalTreatmentLabel = (name: string, priceLabel: string) =>
  `${name} (${priceLabel})`;

export const buildSelfPayerInfoNote = (
  durationMinutes: number | undefined,
  additionalTreatments: string[] | undefined,
): string | undefined => {
  const lines: string[] = [];
  if (durationMinutes) lines.push(`Behandlungsdauer: ${durationMinutes} min`);
  if (additionalTreatments?.length) {
    lines.push(`Zusatzbehandlung: ${additionalTreatments.join(", ")}`);
  }
  return lines.length ? lines.join("\n") : undefined;
};
